export default "__VITE_ASSET__BN8cNiDb__"